module.exports = __webpack_public_path__ + "img/04-1-1行业经验.6cc6a7ee.svg";